<div class="sdps-messaging sdps-messaging--error">
  <span class="sdps-messaging__icon sch-exclamation-octagon"></span>
  <div class="sdps-messaging__text">
    <span id="single-terms-error-text">{{summaryText}}</span>
    <ol class="sdps-messaging--error__formList" *ngFor="let error of errors">
      <li id="single-terms-error">
        <span id="error-text">{{error.messageText}} <a href="javascript:void(0)" (click)="scrollToMessageField(error.messageId)"
            id="single-terms-error-link">{{error.messageField}}</a></span>
      </li>
    </ol>
  </div>
</div>